import { render, staticRenderFns } from "./DocMultiplicadores.vue?vue&type=template&id=7f623f1f&lang=pug&"
import script from "./DocMultiplicadores.vue?vue&type=script&lang=js&"
export * from "./DocMultiplicadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports